import { getAuthUser } from "../helpers/auth";

const usePermissions = (_permissions = []) => {

    const user = getAuthUser();
    const permissions = user?.roles?.flatMap((role: any) => role.permissions) || [];
      return {
      permissions,
      hasPermission: (permission: any) => permissions?.includes(permission)
    };

    // const { data } = useSelector((state: any) => state.login)

    // const permissions = data.roles?.flatMap((role: any) => role.permissions);
    //   return {
    //   permissions,
    //   hasPermission: (permission: any) => permissions?.includes(permission)
    // };
  };
  

  export default usePermissions;
